import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

// Modal blocking de avisos do BE — substitui o toast.warning anterior pra
// replicar o comportamento das MessageDlg do uDebitosIPTU.pas (só fecha
// quando o usuário clica em OK). Preserva \n nas mensagens.
const ModalAvisosIPTU = ({ show, avisos, onOk }) => {
  const lista = Array.isArray(avisos) ? avisos : [];
  return (
    <Modal show={show} onHide={onOk} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title style={{ fontSize: 18 }} className="d-inline-flex align-items-center">
          <FaExclamationTriangle className="text-warning mr-2" />
          Atenção
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {lista.length === 0 ? (
          <div className="text-muted">Sem avisos.</div>
        ) : (
          lista.map((aviso, idx) => (
            <div
              key={`${idx}-${aviso.slice(0, 24)}`}
              style={{ whiteSpace: 'pre-wrap' }}
              className={idx < lista.length - 1 ? 'pb-2 mb-2 border-bottom' : ''}
            >
              {aviso}
            </div>
          ))
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onOk} autoFocus>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAvisosIPTU;
